











import VueOptions from '@utils/VueOptions'
import VenueResourceList from '@superComponents/Venue/VenueResourceList'

settings =
  name: 'VenueList'

  resources:
    venues:
      resourceName: 'venue'
      slug: 'venues'
      infinityScroll: true

  vue:
    components: {
      VenueResourceList,
    }

    computed:
      actionsForVenues: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEdit

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity state, resourceKey, data, options

      bulkEdit: (venues) ->
        query = { venues }
        @$router.push { name: 'VenueBulkEditPage', query }

export default VueOptions.vue settings
